var _path, _g, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiIcon = function SvgAiIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ai-icon_svg__c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 43,
    height: 45
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.753 2.43c-5.404.798-11.138 3.662-15.9 8.424-2.857 2.857-5.032 6.067-6.486 9.34l-.914-.407c1.506-3.387 3.751-6.698 6.693-9.64 4.899-4.899 10.825-7.874 16.461-8.706 5.636-.833 11.019.478 14.747 4.206 3.727 3.727 5.038 9.11 4.206 14.746-.833 5.637-3.808 11.563-8.706 16.46-4.681 4.681-10.299 7.605-15.705 8.582-5.405.977-10.632.011-14.466-3.138l.634-.773c3.556 2.92 8.464 3.865 13.654 2.927 5.189-.938 10.626-3.755 15.176-8.304 4.761-4.762 7.626-10.496 8.423-15.9.798-5.403-.471-10.441-3.923-13.893-3.453-3.452-8.49-4.722-13.894-3.924Z",
    fill: "url(#ai-icon_svg__b)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ai-icon_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#ai-icon_svg__d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 45.5,
    r: 15.5,
    fill: "#0021FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#ai-icon_svg__e)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 27.5,
    r: 15,
    fill: "#116DFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#ai-icon_svg__f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 5.5,
    r: 14,
    fill: "#5FF2AE"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66 4.34c-.37-.37-.6-.83-.68-1.34h-.96c-.08.51-.32.97-.68 1.34-.36.37-.83.6-1.34.68v.96c.51.08.97.32 1.34.68.37.36.6.83.68 1.34h.96c.08-.51.32-.97.68-1.34.36-.37.83-.6 1.34-.68v-.96c-.51-.08-.97-.32-1.34-.68ZM23.5 36C30.404 36 36 30.404 36 23.5S30.404 11 23.5 11 11 16.596 11 23.5 16.596 36 23.5 36ZM43.03 39.97a3.49 3.49 0 0 1-1-1.97h-1.05a3.52 3.52 0 0 1-1 1.97c-.54.53-1.22.89-1.97 1v1.05c.75.12 1.44.46 1.97 1s.89 1.22 1 1.97h1.05c.12-.75.47-1.44 1-1.97a3.52 3.52 0 0 1 1.97-1v-1.05a3.52 3.52 0 0 1-1.97-1Z",
    fill: "#C2E2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 36C30.404 36 36 30.404 36 23.5S30.404 11 23.5 11 11 16.596 11 23.5 16.596 36 23.5 36Z",
    fill: "#C2E2FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.68 25.32A11.332 11.332 0 0 1 17.47 19h-.93c-.38 2.41-1.49 4.6-3.21 6.32a11.331 11.331 0 0 1-6.32 3.21v.93c2.41.38 4.6 1.49 6.32 3.21 1.72 1.72 2.84 3.91 3.21 6.32h.93c.38-2.41 1.49-4.6 3.21-6.32 1.72-1.72 3.91-2.84 6.32-3.21v-.93c-2.41-.38-4.6-1.49-6.32-3.21ZM34 14a5.417 5.417 0 0 1-1.53-3h-.94A5.417 5.417 0 0 1 30 14c-.82.82-1.86 1.35-3 1.53v.94c1.14.18 2.18.71 3 1.53.82.82 1.35 1.86 1.53 3h.94c.18-1.14.71-2.18 1.53-3 .82-.82 1.86-1.35 3-1.53v-.94A5.417 5.417 0 0 1 34 14ZM7 44a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    fill: "#116DFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ai-icon_svg__d",
    x: 0,
    y: 28,
    width: 35,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_3032_23261"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ai-icon_svg__e",
    x: 9,
    y: 0.5,
    width: 54,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_3032_23261"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ai-icon_svg__f",
    x: 11,
    y: -21.5,
    width: 54,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "effect1_foregroundBlur_3032_23261"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ai-icon_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.63 23.5) scale(21.17)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#6F56F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#116DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#19D1DF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgAiIcon;